import AvailableChargingPointScreen from './AvailableChargingPointScreen'
import MaintenanceChargingPointScreen from './MaintenanceChargingPointScreen'
import OccupiedChargingPointScreen from './OccupiedChargingPointScreen'
import FaultedChargingPointScreen from './FaultedChargingPointScreen'
import UnavailableChargingPointScreen from './UnavailableChargingPointScreen'

import InProgressChargingSessionScreen from './InProgressChargingSessionScreen'
import StartingChargingSessionScreen from './StartingChargingSessionScreen'
import FinishingChargingSessionScreen from './FinishingChargingSessionScreen'
import IdleChargingSessionScreen from './IdleChargingSessionScreen'
import ConnectedChargingPointScreen from './ConnectedChargingPointScreen'

export const ChargingPointStatusScreen = {
  AvailableChargingPointScreen,
  ConnectedChargingPointScreen,
  OccupiedChargingPointScreen,
  MaintenanceChargingPointScreen,
  FaultedChargingPointScreen,
  UnavailableChargingPointScreen,
}

export const ChargingSessionStatusScreen = {
  InProgressChargingSessionScreen,
  StartingChargingSessionScreen,
  FinishingChargingSessionScreen,
  IdleChargingSessionScreen,
}
